import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/real-time-collab.svg
 */
const IconRealTimeCollab: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M12.02 4.785a2.394 2.394 0 110-4.787 2.394 2.394 0 010 4.787zm4.772 12.01h7.207a3.604 3.604 0 10-7.207 0zm6.002-6.01a2.393 2.393 0 10-4.71.6h-5.48V8.394h3.026a3.604 3.604 0 10-7.208 0h2.987v2.99h-5.48a2.393 2.393 0 10-.737 1.2h6.215v3.07a2.393 2.393 0 101.196 0V12.59h6.215a2.388 2.388 0 002.575.39 2.394 2.394 0 001.406-2.191l-.005-.005zm-14.387 13.2h7.206a3.6 3.6 0 10-7.203 0h-.003zM0 16.795h7.21a3.604 3.604 0 00-7.21 0z"
      fill="currentColor"
    />
  </svg>
);

export default IconRealTimeCollab;
